module.exports = __webpack_public_path__ + "static/img/public.166beb7.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/public.png
// module id = CJoD
// module chunks = 1